import constants from '../constants';

const Footer = () => {
    return (
    <footer className="footer">
        <div className="footer-shell">
            <div className="footer-brand-block">
                <div className="footer-kicker">Short-Term Rental Operations</div>
                <div className="footer-brand-name">{constants.name}</div>
                <div className="footer-summary">{constants.missionDetails}</div>
            </div>
            <div className="footer-meta-block">
                <div className="footer-section-label">Contact</div>
                <a className="footer-link" href={`mailto:${constants.email}`}>{constants.email}</a>
                <div className="footer-legal-links">
                    <a className="footer-link" href="/terms">Terms of Service</a>
                    <a className="footer-link" href="/privacy">Privacy Policy</a>
                </div>
                <div className="footer-powered">Powered by Bradham Business Platform</div>
            </div>
        </div>
    </footer>
    );
};

export default Footer;